import initializeMenu from './menu'
import initializeCarousel from './carousel'
import initializeScroll from './scroll'
import initializeExpanders from './expander'
import initializeParallax from './parallax'
import initializeMaps from './maps'
import initializeMarquee from './marquee'

window.addEventListener('DOMContentLoaded', (event) => {
    initializeMenu()
    initializeMarquee()
    initializeCarousel()
    initializeScroll()
    initializeParallax()
    initializeExpanders()
    initializeMaps()
})